import React from 'lib/react';
import { EVTypography } from 'lib/components';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { COLOR_BASES, COLOR_INTENSITIES } from './Typography.utils';
import TypographyStyles from './TypographyStyles';

function Typography({
  variant, className, children, fontColor, ...rest
}) {
  const [colorTheme, colorIntensity] = fontColor.split('-');
  const [variantType, fontWeight] = variant.split('-');

  const classes = TypographyStyles({ colorTheme, colorIntensity, fontWeight });
  return (
    <EVTypography
      className={clsx(classes[`type-${variantType}`], classes.root, className)}
      {...rest}
    >
      {children}
    </EVTypography>
  );
}

Typography.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  align: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  fontColor: PropTypes.oneOf(
    COLOR_BASES.flatMap((base) => COLOR_INTENSITIES.map((intensity) => `${base}-${intensity}`)),
  ),
};

Typography.defaultProps = {
  variant: 'body',
  color: 'primary',
  align: 'left',
  className: null,
  fontColor: 'charcoal-900',
};

export default Typography;
